import React, { useState } from "react";
import { connect } from "react-redux";

import { setSortsUsers } from "domain/actions/users/filters";
import { Sorts } from "components/static";
import SortComponent from "components/static/sorts/components/Sort.component";

function SortsPanel({ setSortsUsers, className }) {
  const [createdAt, toggleDate] = useState(null);
  const [firstName, toggleName] = useState(null);
  const [lastName, toggleLastName] = useState(null);

  const valueMethods = {
    createdAt: (val) => toggleDate(val),
    firstName: (val) => toggleName(val),
    lastName: (val) => toggleLastName(val),
  };

  const setValue = (value, type) => {
    for (let key in valueMethods) {
      if (key === type) valueMethods[key](value);
      else {
        valueMethods[key](null);
      }
    }
  };

  const onChange = (value, type) => {
    setValue(value, type);

    let params = {};
    params[type] = value ? "ASC" : "DESC";

    setSortsUsers(params);
  };

  return (
    <Sorts className={className}>
      <div className="p-d-flex">
        <SortComponent
          label="Дата"
          value={createdAt}
          onChange={(value) => onChange(value, "createdAt")}
        />

        <SortComponent
          label="Имя"
          value={firstName}
          onChange={(value) => onChange(value, "firstName")}
        />

        <SortComponent
          label="Фамилия"
          value={lastName}
          onChange={(value) => onChange(value, "lastName")}
        />
      </div>
    </Sorts>
  );
}

export default connect(null, { setSortsUsers })(SortsPanel);
